// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3zNku","colLarge":"styles_colLarge__1sG1b","col":"styles_col__1wue1","colCheckbox":"styles_colCheckbox__22cDS","actions":"styles_actions__1VV75"};